import {Routes} from 'common/src/modules/routing/routing.config';
import routingService from 'common/src/modules/routing/routing.service';
import {CLRoute} from 'common/src/modules/routing/routing.types';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {CLStore} from 'common/src/redux/store';
import {z} from 'zod';
import {TemplateStep} from '../agents/creativeTemplatesManagerAgent/creativeTemplatesManagetAgent.enums';
import {CopilotCreativeTemplatesToolName} from '../copilotCreativeTemplates.enum';
import getTemplateById from '../utils/getTemplateById';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';

const inputSchema = z.object({
  step: z.enum([TemplateStep.Builder, TemplateStep.Map]),
  templateId: z.number(),
});

function navigateToCreativeTemplateBuildOrMapTabTool(store: CLStore) {
  async function execute({
    input: {step, templateId},
  }: ToolExecuteParams<typeof inputSchema>): Promise<ToolResult> {
    const urls: Record<TemplateStep.Builder | TemplateStep.Map, CLRoute> = {
      [TemplateStep.Builder]: Routes.TemplateWorkflowBuilder,
      [TemplateStep.Map]: Routes.TemplateWorkflowMap,
    };

    const template = await getTemplateById(templateId, store);

    if (!template) {
      return toolError(`Template with ID ${templateId} not found.`);
    }

    const format = template.formats[0]?.format.formatString;

    routingService.goTo({
      url: urls[step as TemplateStep.Builder | TemplateStep.Map],
      pathParams: {templateId},
      queryParams: format ? {format} : undefined,
    });

    return toolResult(
      `Navigated to creative template ${step} page` +
        (format ? ` with format ${format}` : ' without format'),
    );
  }

  return tool({
    name: CopilotCreativeTemplatesToolName.NavigateToCreativeTemplateBuildOrMapTab,
    description: 'Navigate to creative template workflow step (Builder or Map)',
    displayName: 'Navigating',
    execute,
    inputSchema,
  });
}

export default navigateToCreativeTemplateBuildOrMapTabTool;
